import { convertToGAIndex } from '@noths/polaris-client-google-analytics';

import type { Level1Item, Level3Item } from 'client-site-chrome-ui/types/departmentsNav';

const compareNavItems = (a: Level3Item, b: Level3Item) => a.title === b.title && a.url === b.url;

const formatEventLabel = (data: (string | number)[]) => data.join('|');

export const getTrackingEventLabel = (
  level1Items: Level1Item[],
  search: Level3Item,
): string | null => {
  // find matching level 1 item
  const level1ItemIndex = level1Items.findIndex((level1Item) =>
    compareNavItems(level1Item, search),
  );

  if (level1ItemIndex >= 0) {
    return formatEventLabel([
      1,
      convertToGAIndex(level1ItemIndex),
      level1Items[level1ItemIndex].title,
    ]);
  }

  // find matching level 2 item
  for (let level1Index = 0; level1Index < level1Items.length; level1Index++) {
    const level1Item = level1Items[level1Index];
    const level2Index = level1Item.items.findIndex((level2Item) => {
      return compareNavItems(level2Item, search);
    });

    if (level2Index >= 0) {
      const level2Item = level1Item.items[level2Index];

      return formatEventLabel([
        1,
        convertToGAIndex(level1Index),
        level1Item.title,
        2,
        convertToGAIndex(level2Index),
        level2Item.title,
      ]);
    }
  }

  // find matching level 3 item
  for (let level1Index = 0; level1Index < level1Items.length; level1Index++) {
    const level1Item = level1Items[level1Index];
    for (let columnIndex = 0; columnIndex < level1Item.items.length; columnIndex++) {
      const column = level1Item.items[columnIndex];
      const level3Index = column.items.findIndex((level3Item) =>
        compareNavItems(level3Item, search),
      );

      if (level3Index >= 0) {
        const level3Item = column.items[level3Index];

        return formatEventLabel([
          1,
          convertToGAIndex(level1Index),
          level1Item.title,
          2,
          convertToGAIndex(columnIndex),
          column.title,
          3,
          convertToGAIndex(level3Index),
          level3Item.title,
        ]);
      }
    }
  }

  return null;
};
